import ConsumerEngineSidebarRoutes from "../App/ConsumerEngine/sidebarRoutes";
import DataManagementSidebarRoutes from "../App/DataManagement/sidebarRoutes";
import InsightsSidebarRoutes from "../App/Insights/sidebarRoutes";
import InsightsHubSidebarRoutes from "../App/InsightsHub/sidebarRoutes";
import ProviderDirectoryRoutes from "../App/ProviderDirectory/sidebarRoutes";
import SystemManagementSidebarRoutes from "../App/SystemManagement/sidebarRoutes";

// This is an array that holds options for the application dropdown and permission mapper
export default [
  {
    key: "Consumer360",
    displayName: "Consumer 360",
    icon: "fa-kit fa-hdp-app-consumer-360",
    permission: "entity_unification.view_consumer",
    routes: [
      {
        header: "",
        children: [
          {
            name: "",
            route: "/consumer-360",
            permissions: ["entity_unification.view_consumer"],
          },
        ],
      },
    ],
    url: "consumer-360",
    color: "#864CCC",
    group: "Activation",
  },
  {
    key: "Provider360",
    displayName: "Provider 360",
    icon: "fa-kit fa-hdp-app-provider",
    permission: "accounts.provider_360_access",
    routes: ProviderDirectoryRoutes,
    url: "provider-360",
    color: "#23A6F9",
    group: "Activation",
  },
  {
    key: "InsightsHub",
    displayName: "Insights Hub",
    icon: "fa-kit fa-hdp-app-insights-hub",
    // permission: "accounts.leap_insights_access",
    permission: null,
    routes: InsightsHubSidebarRoutes,
    url: "insights-hub",
    color: "#0D9488",
    group: "Performance Analytics",
  },
  {
    key: "InsightsStudio",
    displayName: "Insights Studio",
    icon: "fa-kit fa-hdp-app-insights-studio",
    permission: "accounts.insights_studio_access",
    routes: InsightsSidebarRoutes,
    url: "insights-studio",
    color: "#F9BE28",
    group: "Performance Analytics",
  },
  {
    key: "DataHub",
    displayName: "Data Hub",
    icon: "fa-kit fa-hdp-app-data-hub",
    permission: "accounts.data_hub_access",
    routes: DataManagementSidebarRoutes,
    url: "data-hub",
    color: "#ED8F1C",
    group: "Data Platform",
  },
  {
    key: "ConsumerEngine",
    displayName: "Consumer Engine",
    icon: "fa-kit fa-hdp-app-consumer-engine",
    permission: "accounts.consumer_engine_access",
    routes: ConsumerEngineSidebarRoutes,
    url: "consumer-engine",
    color: "#B91D70",
    group: "Data Platform",
  },
  {
    key: "System",
    displayName: "System",
    icon: "fa-kit fa-hdp-app-settings",
    permission: "accounts.system_management_access",
    routes: SystemManagementSidebarRoutes,
    url: "system",
    color: "#005b93",
  },
] as const;
